import { GetBannerRequest } from '@/types/Admin';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';

export const getBanner = createAsyncThunk(
  'getBanner',
  async ({
    product,
    page,
    isAffiliate,
    agentCode,
    countryCode,
  }: {
    product: string;
    page: string;
    isAffiliate: boolean;
    countryCode: string;
    agentCode: string;
  }) => {
    const request: GetBannerRequest = {
      product,
      page,
      countryCode,
      isAffiliate,
      agentCode,
    };
    try {
      const relativeUrl = 'MY/BannerConfig/GetBanner/';
      const apiUrl = `/admin/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return '';
    }
  },
);
